export default {
  'promoHeader': 'Muistitko?',
  'add':'Lisää',
  'pickSize':'Valitse koko',
  'cartHeader':'Ostoskorisi:',
  'addUniid':'Lisää nimi ja numero',
  'remove':'Siirrä',
  'freeDelivery':'Hei, sait ilmaisen toimituksen!',
  'toCheckout':'Jatka maksuun',
  'totalPrice':'Summa:',
  'totalDiscount':'Alennus:',
  'deliveryPrice':'Toimituskulut:',
  'size':'Koko:',
  'getTomoz':'',
  'totalVAT':'ALV. summa:',
  'consent': 'Yes - I allow Unisport to send me email and sms\'s on similar football products. I can unsubscribe at any time in the email or by un-ticking this box, should the communication not be as expected.'
}